import { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import { useEngagementEditor } from './EngagementEditorContext';
import { CriteriaWeighting } from './CriteriaWeighting';
import { DetailedFunctionalityMatrix } from './DetailedFunctionalityMatrix';
import { ComponentSpinner } from '../../Loading/ComponentSpinner';
import { LoadError } from '../LoadError';

export const FeatureMatrixPanel = () => {
  const { canEdit, functionalityMatrix } = useEngagementEditor();
  const {
    criteria,
    failed,
    refresh,
    updateCriterion,
    selectFeature,
    addCriterion,
    addFeature,
    removeCriterion,
    removeFeature
  } = functionalityMatrix;
  const [showDetail, setShowDetail] = useState(false);

  useEffect(() => {
    refresh?.();
  }, [refresh]);

  const loadError = failed && (
    <LoadError
      subject="the Functionality Matrix"
      consequence={criteria ? 'it may not show the latest selections' : 'there is nothing to show yet'}
      onRetry={refresh}
    />
  );

  if (!criteria) {
    if (loadError) return loadError;
    return <ComponentSpinner sx={{ padding: '3rem' }} />;
  }

  if (criteria.length === 0) {
    return (
      <Alert severity="info">
        This engagement was created before the Functionality Matrix existed, so it has none.
      </Alert>
    );
  }

  if (showDetail) {
    return (
      <Box className="flex flex-col gap-4">
        {loadError}
        <DetailedFunctionalityMatrix
          criteria={criteria}
          canEdit={canEdit}
          onChangeCriterion={updateCriterion}
          onSelectFeature={selectFeature}
          onAddCriterion={addCriterion}
          onAddFeature={addFeature}
          onRemoveCriterion={removeCriterion}
          onRemoveFeature={removeFeature}
          onBack={() => setShowDetail(false)}
        />
      </Box>
    );
  }

  return (
    <Box className="flex flex-col gap-4">
      {loadError}
      <CriteriaWeighting
        criteria={criteria}
        canEdit={canEdit}
        onChangeCriterion={updateCriterion}
        onOpenDetail={() => setShowDetail(true)}
      />
    </Box>
  );
};
